import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IListCRMPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listCRMSlice = createSlice({
    name: 'CRM/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListCRMPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onUpdateList(state, action) {
            state.status = STATUS.READY
            const index = state.data.findIndex(item => item._id === action.payload._id)
            if (index !== -1) {
                state.data.splice(index, 1)
            }
        }
    }
})

export const listCRMActions = listCRMSlice.actions
export default listCRMSlice.reducer
